import { connect } from 'react-redux';
import { setSearchValue } from 'actions/search';
import Input from './Input';

const mapDispatchToProps = {
  setSearchValue
};

export default connect(null, mapDispatchToProps)(Input);



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Input/InputContainer.js